import React, { useState, useEffect } from 'react';
import Calendar from './child/Calendar';
import { updateWorkOrder, getPaginatedWorkOrders } from '../api/work-orderAPI';

const WorkOrderCalendarLayer = ({
  handleEdit,
  setShowModal,
  setNewWorkOrder,
  setEditingId,
  setFormReadOnly,
  refreshTrigger,
  filters = {}
}) => {

  const [calendarWorkOrders, setCalendarWorkOrders] = useState([]);
  const [currentRange, setCurrentRange] = useState({ start: null, end: null });

  useEffect(() => {
    if (!currentRange.start || !currentRange.end) return;
    handleCalendarRangeChange(currentRange.start, currentRange.end);
  }, [refreshTrigger, filters]);

  const handleCalendarRangeChange = async (start, end) => {
    setCurrentRange({ start, end });
    try {
      const resp = await getPaginatedWorkOrders({
        page: 1,
        pageSize: 1000,
        scheduledAt: start.toISOString(),
        dueDate: end.toISOString(),
        ...filters,
      });
      const workOrders = Array.isArray(resp.data) ? resp.data : resp;
      setCalendarWorkOrders(workOrders);
    } catch (err) {
      console.error('Error loading work orders for calendar:', err);
    }
  };

  const updateLocalWorkOrder = (id, start, end) => {
    setCalendarWorkOrders((prev) =>
      prev.map((wo) =>
        wo.id === id ? { ...wo, scheduledAt: start, dueDate: end } : wo
      )
    );
  };

  const handleEventChange = async (info) => {
    const id = info.event.extendedProps.id;
    const startStr = info.event.start?.toISOString();
    const endStr = info.event.end?.toISOString();
    try {
      await updateWorkOrder(id, { scheduledAt: startStr, dueDate: endStr });
      updateLocalWorkOrder(id, startStr, endStr);
    } catch (err) {
      console.error('Error updating work order dates:', err);
      info.revert();
    }
  };

  const visibleWorkOrders = Array.isArray(calendarWorkOrders)
    ? calendarWorkOrders.filter((wo) => {
        const isActiveStatus =
          wo.statusId === 1 || wo.statusId === 2;
        // const isAdvancedAsset = Number(wo.asset?.PlanningTypeId) === 1;
        // const isLinkedToEvent = wo.eventId != null;
        // Only show advanced assets that are linked to events
        // if (isAdvancedAsset && !isLinkedToEvent) return false;

        return isActiveStatus;
      })
    : [];

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100 p-0">
          <div className="card-body p-0">
            <div id="calendar" />
            <Calendar
              workOrders={visibleWorkOrders}
              onEventClick={(wo) => {
                handleEdit?.(wo);
              }}
              onDateSelect={(info) => {
                setNewWorkOrder({
                  scheduledAt: info.startStr,
                  dueDate: info.endStr,
                });
                setEditingId(null);
                setFormReadOnly(false);
                setShowModal(true);
              }}
              onDateRangeChange={handleCalendarRangeChange}
              onEventDrop={handleEventChange}
              onEventResize={handleEventChange}
            />
          </div>
          </div>
        </div>
      </div>
  );
};

export default WorkOrderCalendarLayer;
